// src/ones/OnePastor.js
import { useContext } from "react"
import { AppContext } from "../App"
import { MdPerson, MdPlace, MdChurch } from "react-icons/md";

export default function OnePastor({data}) {

	const appContext = useContext(AppContext);

	function view() {
		appContext.navTo({
			item: 'rider-portal',
			subItem: data.uuid,
			moreItem: 'account-home',
		})
	}

	return (
		<div
			style={{
				width: "100%",
				marginBottom: "10px",
				padding: "15px",
				cursor: "pointer",
			}}
			className="bg-surface"
			onClick={view}
		>
			
			<h6
				style={{
					fontSize: "18px",
					textTransform: "capitalize",
				}}
				className="font-semi-bold"
			>
				{data.firstName} {data.middleName} {data.lastName}
			</h6>

			<h6
				style={{
					fontSize: "28px",
					textTransform: "uppercase",
				}}
				className="font-semi-bold text-muted mt-3 mb-3"
			>
				{data.vehicleRegistrationNumber}
			</h6>

			<h6
				style={{
					fontSize: "12px",
					textTransform: "capitalize",
				}}
				className="font-regular text-end"
			>
				{data.vehicleBrand} | {data.vehicleModel} | {data.vehicleColor}
			</h6>
		</div>
	)
}
